function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M28.76 3.24l25.342 25.343L28.76 53.925",
  stroke: "#03DAE1",
  strokeWidth: 5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.102 28.583H3.417",
  stroke: "#03DAE1",
  strokeWidth: 5,
  className: "shaft"
});

function SvgArrowRightBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTmpZaUlHaGxhV2RvZEQwaU5UY2lJSFpwWlhkQ2IzZzlJakFnTUNBMU9TQTFOeUlnWm1sc2JEMGlibTl1WlNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWo0S1BIQmhkR2dnWkQwaVRUSTRMamMxT1RnZ015NHlNems1T1V3MU5DNHhNREkxSURJNExqVTRNamRNTWpndU56VTVPQ0ExTXk0NU1qVTBJaUJ6ZEhKdmEyVTlJaU13TTBSQlJURWlJSE4wY205clpTMTNhV1IwYUQwaU5TSXZQZ284Y0dGMGFDQmtQU0pOTlRRdU1UQXlOU0F5T0M0MU9ESTNTRE11TkRFM01EWWlJSE4wY205clpUMGlJekF6UkVGRk1TSWdjM1J5YjJ0bExYZHBaSFJvUFNJMUlpQmpiR0Z6Y3owaWMyaGhablFpTHo0S1BDOXpkbWMrQ2c9PSI=";
export { SvgArrowRightBig as ReactComponent };